import { cx } from '@emotion/css';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Card, CardContent } from '@mui/material';
import React from 'react';
import { DEFAULT_TYPOGRAPHY_VARIANT } from './Alert.constants';
import useStyles from './Alert.styles';
/**
 * @deprecated This component is deprecated and will be removed in future releases. Please use AlertV2 instead.
 */
export function Alert(props) {
    const { children, className, id, variant, typographyVariant, iconIsEnabled = false, iconOverride } = props;
    const classes = useStyles(Object.assign(Object.assign({}, props), { typographyVariant: typographyVariant || DEFAULT_TYPOGRAPHY_VARIANT }));
    const variantClassName = variant ? { [variant]: true } : {};
    const renderIcon = () => {
        if (iconOverride) {
            return iconOverride;
        }
        switch (variant) {
            case 'success':
                return React.createElement(CheckCircleOutlineRoundedIcon, null);
            case 'error':
                return React.createElement(ErrorRoundedIcon, null);
            case 'info':
                return React.createElement(InfoOutlinedIcon, null);
            case 'warning':
                return React.createElement(WarningAmberRoundedIcon, null);
            default:
                return React.createElement(WarningAmberRoundedIcon, null);
        }
    };
    return (React.createElement(Card, { variant: "outlined", className: cx(className, classes.root, variant ? { [variant]: true } : {}), id: id },
        React.createElement(CardContent, { className: cx(classes.content, variant ? { [variant]: true } : {}) },
            iconIsEnabled ? React.createElement("div", { className: cx(classes.iconWrapper, variantClassName) }, renderIcon()) : null,
            children)));
}
//# sourceMappingURL=Alert.js.map